import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Template } from "../api";
import { BaseResource } from "@kgsport-cms/common";
import "../common";
export var AuthService = /*#__PURE__*/function (_BaseResource) {
  _inherits(AuthService, _BaseResource);
  var _super = _createSuper(AuthService);
  function AuthService() {
    _classCallCheck(this, AuthService);
    return _super.apply(this, arguments);
  }
  _createClass(AuthService, [{
    key: "accountlogin",
    value: function accountlogin(parms) {
      //账号登录，短信登录
      return this.requester.post(Template.Auth.accountlogin, parms);
    }
  }, {
    key: "phoneLogin",
    value: function phoneLogin(parms) {
      return this.requester.post(Template.Auth.phoneLogin, parms);
    }
  }, {
    key: "refreshToken",
    value: function refreshToken(parms) {
      //刷新token 凭证
      return this.requester.get(Template.Auth.refreshToken, parms);
    }
  }, {
    key: "logout",
    value: function logout() {
      //账号退出
      return this.requester.post(Template.Auth.uersLogut);
    }
  }, {
    key: "memberCancellation",
    value: function memberCancellation() {
      //会员注销
      return this.requester.post(Template.Auth.memberCancellation);
    }
  }, {
    key: "cancelledByName",
    value: function cancelledByName(data) {
      //通过用户名密码注销接口
      return this.requester.post(Template.Auth.cancelledByName, data);
    }
  }, {
    key: "register",
    value: function register(options) {
      return this.requester.post(Template.Auth.userRegister, options);
    }
    //手机注册
  }, {
    key: "phoneRegister",
    value: function phoneRegister(options) {
      return this.requester.post(Template.Auth.phoneRegister, options);
    }
  }, {
    key: "forgotPass",
    value: function forgotPass(param) {
      return this.requester.post(Template.Auth.userForgotPass, param);
    }
    //第三方登录
  }, {
    key: "thirdLogin",
    value: function thirdLogin(params) {
      return this.requester.post(Template.Auth.thirdLogin, params);
    }
  }]);
  return AuthService;
}(BaseResource);
export var ConfigService = /*#__PURE__*/function (_BaseResource2) {
  _inherits(ConfigService, _BaseResource2);
  var _super2 = _createSuper(ConfigService);
  function ConfigService() {
    _classCallCheck(this, ConfigService);
    return _super2.apply(this, arguments);
  }
  _createClass(ConfigService, [{
    key: "registerConfig",
    value: function registerConfig() {
      return this.requester.get(Template.Config.getRegister);
    }
  }, {
    key: "activityConfig",
    value: function activityConfig() {
      return this.requester.get(Template.Config.activity);
    }
  }, {
    key: "bankConfig",
    value: function bankConfig(params) {
      return this.requester.get(Template.Config.bank, {
        params
      });
    }
    // 获取系统配置
  }, {
    key: "systemConfig",
    value: function systemConfig() {
      return this.requester.get(Template.Config.getSystem);
    }
    // 获取手机国际区号列表
  }, {
    key: "dialCode",
    value: function dialCode() {
      return this.requester.get(Template.Config.getDialCode);
    }
    // 获取虚拟币相关配置
  }, {
    key: "getVirtualCurrency",
    value: function getVirtualCurrency(params) {
      return this.requester.get(Template.Config.getVirtualCurrency, {
        params
      });
    }
  }, {
    key: "getVirtualCoin",
    value: function getVirtualCoin(params) {
      return this.requester.get(Template.Config.getVirtualCoin, {
        params
      });
    }
    // 获取浮窗列表接口
  }, {
    key: "getFloatList",
    value: function getFloatList() {
      return this.requester.get(Template.Config.getFloatList);
    }
    // 获取活动悬浮窗
  }, {
    key: "getActivityFloat",
    value: function getActivityFloat() {
      return this.requester.get(Template.Config.getActivityFloat);
    }
    // 手动签到
  }, {
    key: "signIn",
    value: function signIn() {
      return this.requester.post(Template.Config.signIn);
    }
    // 查询签到详情
  }, {
    key: "getSignInDetail",
    value: function getSignInDetail() {
      return this.requester.get(Template.Config.getSignInDetail);
    }
    // 领取神秘嘉奖
  }, {
    key: "getMysterious",
    value: function getMysterious() {
      return this.requester.get(Template.Config.getMysterious);
    }
    // 神秘嘉奖详情
  }, {
    key: "getMysteriousDetail",
    value: function getMysteriousDetail() {
      return this.requester.get(Template.Config.getMysteriousDetail);
    }
  }, {
    key: "getDomainList",
    value: function getDomainList() {
      return this.requester.get(Template.Config.getDomainList);
    }
    // 获取租户相关配置
  }, {
    key: "getTenantConfig",
    value: function getTenantConfig() {
      return this.requester.post(Template.Config.getTenantConfigApi);
    }
    // 获取客服配置信息
  }, {
    key: "getCustomerInfo",
    value: function getCustomerInfo(params) {
      return this.requester.get(Template.Config.getCustomerInfo, {
        params
      });
    }
    // 获取ip对应区域
  }, {
    key: "getIpArea",
    value: function getIpArea(params) {
      return this.requester.get(Template.Config.getIpArea, {
        params
      });
    }
    // 获取个人资料配置
  }, {
    key: "getProfile",
    value: function getProfile() {
      return this.requester.get(Template.Config.getProfile);
    }
  }]);
  return ConfigService;
}(BaseResource);
export var CommonService = /*#__PURE__*/function (_BaseResource3) {
  _inherits(CommonService, _BaseResource3);
  var _super3 = _createSuper(CommonService);
  function CommonService() {
    _classCallCheck(this, CommonService);
    return _super3.apply(this, arguments);
  }
  _createClass(CommonService, [{
    key: "captchaCode",
    value: function captchaCode(params) {
      //图形验证 vs 极验
      return this.requester.get(Template.Common.captchaCode, {
        params
      });
    }
  }, {
    key: "smsCode",
    value: function smsCode(parms) {
      //发送短信码
      return this.requester.get(Template.Common.smsCode, parms);
    }
  }, {
    key: "notice",
    value: function notice(params) {
      return this.requester.get(Template.Common.notice, {
        params
      });
    }
  }, {
    key: "upload",
    value: function upload(file) {
      return this.requester.post(Template.Common.upload, file);
    }
  }]);
  return CommonService;
}(BaseResource);